import React, { useEffect, useState } from 'react';
import { useAuth } from '../state/AuthProvider';
import Card from './Card';
import Input from './Input';
import Button from './Button';
import '../assets/styles.css';
import Link from './Link';
import { useChat } from '../state/ChatProvider';

const Authorization = () => {
    const { logOut } = useAuth();
    const { endChat } = useChat();
    const [code, setCode] = useState('');
    const [codeValidationMessage, setCodeValidationMessage] = useState('');
    const [resendButtonDisabled, setResendButtonDisabled] = useState(true);
    const [resendCountdown, setResendCountdown] = useState(30);

    const {
        userEmail,
        authorize,
        setRequireAuthorization,
        resendAuthorizationCode,
        authorizationError,
        clearAuthorizationError,
        isLoading
    } = useAuth();

    useEffect(() => {
        setTimeout(() => {
            setResendCountdown(30);
            setResendButtonDisabled(false);
        }, 30000);
    }, []);

    useEffect(() => {
        setCodeValidationMessage(authorizationError);
    }, [authorizationError]);

    useEffect(() => {
        let countdownInterval;

        if (resendButtonDisabled) {
            countdownInterval = setInterval(() => {
                setResendCountdown((prevCountdown) => prevCountdown - 1);
            }, 1000);
        }

        return () => clearInterval(countdownInterval);
    }, [resendButtonDisabled]);

    const handleSubmit = async () => {
        if (!code) {
            setCodeValidationMessage('Please enter the code');
            return;
        }
        clearAuthorizationError();
        await authorize(code);
    };

    const validateCode = () => {
        if (!code) {
            setCodeValidationMessage('Please enter the code');
            return;
        }

        const regex = /^\d{6}$/;
        const isValid = regex.test(code);
        if (!isValid) {
            setCodeValidationMessage('The code is not valid.');
            return;
        }
        setCodeValidationMessage('');
    };

    const handleCodeResend = async () => {
        if (resendButtonDisabled) {
            return;
        }

        setResendButtonDisabled(true);

        await resendAuthorizationCode();
        clearAuthorizationError();

        setTimeout(() => {
            setResendButtonDisabled(false);
            setResendCountdown(30);
        }, 30000);
    };

    const handleBackToChat = () => {
        setRequireAuthorization(false);
        clearAuthorizationError();
    };

    const handleLogout = async () => {
        await endChat();
        await logOut();
    }

    return (
        <Card>
            <div className='_kanis_card_title'>Verification required</div>
            <div className='_kanis_card_subtitle' >
                To answer this question we need to verify your email. We sent a 6 digit code to <b>{userEmail || ''}</b>
            </div>
            <Input
                name='code'
                value={code}
                placeholder='6 digit code'
                validationMessage={codeValidationMessage}
                onChange={(e) => setCode(e.target.value)}
                onBlur={validateCode}
                disabled={isLoading}
            />
            <div style={{ display: 'flex', gap: '8px' }}>
                <Button type='primary' onClick={handleSubmit} disabled={isLoading}>
                    Enter
                </Button>
                <Button type='outline' onClick={handleBackToChat} disabled={isLoading}>
                    Back to chat
                </Button>
                <Button 
                    type='outline' onClick={handleCodeResend} 
                    disabled={resendButtonDisabled || isLoading}>
                    Resend
                </Button>
            </div>
            <div className='_kanis_card_subtitle'>
                {resendButtonDisabled ? `Resend new code in ${resendCountdown} seconds` : ''}
            </div>
            <Link onClick={handleLogout}>Log in with a different email</Link>
        </Card>
    );
};

export default Authorization;
